export const TOTAL_RESULTS_FIRST_THRESHOLD = 5;
export const TOTAL_RESULTS_SECOND_THRESHOLD = 10;



// WEBPACK FOOTER //
// ./app/utils/adNormalizers/constants.js